<template>
  <div class="footerContainer">
    <img v-if="prepaidcardData.temImg" :src="lang == 'zh' ? prepaidcardData.temImg.cnImg : prepaidcardData.temImg.enImg"/>
  </div>
</template>

<script>
  export default {
    name: "prepaidcard",
    data() {
      return {
        prepaidcardData: '',
      }
    },
    computed: {
      lang() {
        return this.$i18n.locale;
      },
    },
    created() {
      
    },
    mounted() {
      this.getTemplateByGroup()
    },
    beforeRouteUpdate(to,form,next){
      
    },
    methods: {
      getTemplateByGroup() {
        this.$post("getTemplateByGroup",{
          group: 'Rules'
        })
        .then(res => {
          if(res.data.code == 200){
            this.prepaidcardData = res.data.data[0];
          }
        },err => {
          this.errMsg = err
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  
</style>
